module.exports = __webpack_public_path__ + "assets/img/bg-female-689eace3.png";